module.exports = __webpack_public_path__ + "img/coinbankB34.73915c1c.jpg";